import { type NestedCSSProperties, type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../styles.constants';

export const navigationItem = (isActive?: boolean, isCollapsed?: boolean): NestedCSSProperties => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  width: '100%',
  boxSizing: 'border-box',
  padding: isCollapsed ? '10px 0' : '10px 12px',
  justifyContent: isCollapsed ? 'center' : 'flex-start',
  borderRadius: 12,
  cursor: 'pointer',
  transition: 'background-color 150ms ease, color 150ms ease',
  backgroundColor: isActive === true ? StyleConstants.NAVIGATION_ACCENT_SOFT_COLOR : StyleConstants.TRANSPARENT_COLOR,
  color: isActive === true ? StyleConstants.NAVIGATION_ACCENT_TEXT_COLOR : StyleConstants.WHITE_COLOR,
  '-moz-user-select': '-moz-none',
  '-webkit-user-select': 'none',
  userSelect: 'none',
  $nest: {
    '&:hover': {
      backgroundColor: isActive === true ? StyleConstants.NAVIGATION_ACCENT_SOFT_COLOR : StyleConstants.NAVIGATION_HOVER_COLOR,
    },
  },
});

export const activeIndicator: CSSProperties = {
  position: 'absolute',
  left: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  height: 20,
  width: 3,
  borderRadius: 3,
  backgroundColor: StyleConstants.ORANGE_COLOR,
};

export const icon: CSSProperties = {
  flexShrink: 0,
  height: 19,
  width: 19,
};

export const chevronContainer: CSSProperties = {
  width: 50,
};

export const iconContainer: CSSProperties = {
  marginLeft: 8,
  width: 50,
};

export const title: CSSProperties = {
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: 14,
  fontWeight: 600,
  lineHeight: '20px',
  color: 'inherit',
  // Long labels (e.g. NL "Registreren officemanagers") wrap onto a second line
  // instead of being truncated.
  whiteSpace: 'normal',
  overflowWrap: 'break-word',
};
